export const publicMethods = {
  methods: {
    // 加密字段要打上*号的（如：手机号，证件号码，姓名等）
    encryption(field, start, num) {  // 从field的第start个字符开始，打num个*号
      let asterisk = ''
      for (let i = 0; i < num; i++) {
        asterisk += '*'
      }
      // 从第start个字符开始，第start个字符的位置是start-1（因为第一个字符的位置是0）
      let startPosition = start - 1
      // 截取field的第0个位置到第startPosition个位置 + num个星号* + 截取field的第 （startPosition+num） 个位置一直到结束
      return field.substring(0, startPosition) + asterisk + field.substring(startPosition + num);
    },

    // 校验18位数身份证号是否正确
    id_card_mix(code) {
      let city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      let tip = "";
      let pass = true;
      let reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
      if (!code || !code.match(reg)) {
        tip = "身份证号格式错误";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('');
          //∑(ai×Wi)(mod 11)
          //加权因子
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          //校验位
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          let sum = 0;
          let ai = 0;
          let wi = 0;
          for (let i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          let last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = "校验位错误";
            pass = false;
          }
        }
      }

      if (pass) return true;
      return false;
    },

    // 通过18位数身份证号计算性别和出生日期
    analyzeIDCard(IDCard) {
      let sexAndAge = {};
      // 获取用户身份证号码
      let userCard = IDCard;
      // 如果身份证号码为 undefind 则返回空
      if (!userCard) {
        return sexAndAge;
      }
      // 获取性别
      if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
        sexAndAge.sex = '男'
      } else {
        sexAndAge.sex = '女'
      }
      // 获取出生年月日
      //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
      let yearBirth = userCard.substring(6, 10);
      let monthBirth = userCard.substring(10, 12);
      let dayBirth = userCard.substring(12, 14);
      let birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
      // 获取当前年月日并计算年龄
      let myDate = new Date();
      let monthNow = myDate.getMonth() + 1;
      let dayNow = myDate.getDay();
      let age = myDate.getFullYear() - yearBirth;
      if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
        age--;
      }
      //得到出生日期
      sexAndAge.birthday = birthday;
      // 得到年龄
      sexAndAge.age = age;
      // 返回性别和年龄
      return sexAndAge;
    },

    // 校验15位数身份证号是否正确
    id_card_15_mix(num) {
      if (!num) {
        return false
      }
      num = num.toUpperCase() // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
      if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
        // alert('输入的身份证号长度不对，或者号码不符合规定！n15位号码应全为数字，18位号码末位可以为数字或X。');
        return false
      }
      // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      // 下面分别分析出生日期和校验位
      let re
      const len = num.length
      if (len === 15) {
        re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
        const arrSplit = num.match(re) // 检查生日日期是否正确
        const dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4])
        const bGoodDay = (dtmBirth.getYear() === Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) === Number(arrSplit[3])) && (dtmBirth.getDate() === Number(arrSplit[4]))
        if (!bGoodDay) {
          // alert('输入的身份证号里出生日期不对！');
          return false
        } else {
          // 将15位身份证转成18位//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          // const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
          // let nTemp = 0
          // num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6)
          // for (let i = 0; i < 17; i++) {
          //   nTemp += num.substr(i, 1) * arrInt[i]
          // }
          // num += arrCh[nTemp % 11]
          return true
        }
      }
    },

    // 通过15位数身份证号计算性别和出生日期（实际是把15位身份证转换成18位的 再调用analyzeIDCard方法算出）
    analyze15IDCard(IDCard) {

      let re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
      const arrSplit = IDCard.match(re) // 检查生日日期是否正确
      const dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4])
      const bGoodDay = (dtmBirth.getYear() === Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) === Number(arrSplit[3])) && (dtmBirth.getDate() === Number(arrSplit[4]))
      if (!bGoodDay) {
        // alert('输入的身份证号里出生日期不对！');
        Toast('请核实身份证信息')
        return
      } else {
        // 将15位身份证转成18位//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        let nTemp = 0
        let to18idCard = IDCard.substr(0, 6) + '19' + IDCard.substr(6, IDCard.length - 6)
        for (let i = 0; i < 17; i++) {
          nTemp += to18idCard.substr(i, 1) * arrInt[i]
        }
        to18idCard += arrCh[nTemp % 11]
        console.log(to18idCard)
        // 将15位转换撑18位再算出年龄、性别、出生日期
        const agesex = this.analyzeIDCard(to18idCard);
        return agesex

      }
    },

    // 校验手机号是否正确
    isPhoneAvailable(pone) {
      let myReg = /^1[3456789]\d{9}$/
      if (!myReg.test(pone)) {
        console.log('手机号校验失败')
        return false;
      } else {
        console.log('手机号校验成功')
        return true;
      }
    },

    // 校验邮箱是否正确
    isEmailAvailable(email) {
      let myReg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
      if (!myReg.test(email)) {
        console.log('邮箱失败')
        return false;
      } else {
        console.log('邮箱成功')
        return true;
      }
    },

    // 通过出生日期计算年龄
    analyzeBirthday(birthday) {
      // birthday的格式为2021-01-01,如果birthday传过来的格式直接是new Date()的，需要做如下的转换
      // let now_date = birthday
      // let Y = now_date.getFullYear()
      // let M = (now_date.getMonth() + 1 < 10 ? '0' + (now_date.getMonth() + 1) : now_date.getMonth() + 1)
      // let D = (now_date.getDate() < 10 ? '0' + now_date.getDate() : now_date.getDate())
      // birthday = Y + '-' + M + '-' + D

      let yearBirth = birthday.substring(0, 4);
      let monthBirth = birthday.substring(5, 7);
      let dayBirth = birthday.substring(8, 10);
      // 获取当前年月日并计算年龄
      let myDate = new Date();
      let monthNow = myDate.getMonth() + 1;
      let dayNow = myDate.getDay();
      let age = myDate.getFullYear() - yearBirth;
      if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
        age--;
      }
      // 得到年龄
      return age;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin.js